import styles from "./ChildAlert.module.scss";
import { Action } from "../Alerts/Action";
import { ChildAlertProps } from "./ChildAlert.props";

export const ChildAlert = ({ title, message, action }: ChildAlertProps) => (
  <div className="alert__panel-item">
    <div className={`alert__container ${styles.container}`}>
      <span>
        {title} {message}
      </span>

      <Action className={styles.action} variant="secondary" action={action} />
    </div>
  </div>
);
